import { Grid } from "@mui/material";
import { fDate } from "../../../utils/formatTime";

const CategoryDetails = (_props) => {
    const { candidateData, claimedMsg, className } = _props
    return (
        <fieldset className={`${className}--fieldset categoryDetails`}>
            <legend className={`${className}--legend`}>
                Category / Sub Category Reservation Details
            </legend>
            {/* for web preview */}
            <div className="print-web">
                <Grid container spacing={1} alignItems={"center"}>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--text`}>Category</p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--subText custom-rht2`}>
                            {candidateData?.category}
                        </p>
                    </Grid>
                    {/* {candidateData?.category === "EWS" && (
                          <>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                              <p className="final-preview--textred">
                                आर्थिक रूप से कमजोर वर्ग
                              </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={0} xs={0}></Grid>
                          </>
                        )} */}
                    {candidateData?.certification_issuing_authority && (
                        <>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    Certification Issuing Authority
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {candidateData?.certification_issuing_authority}
                                </p>
                            </Grid>
                        </>
                    )}
                    {candidateData?.certification_issuing_date && (
                        <>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    Certificate Issuing Date
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {fDate(
                                        candidateData?.certification_issuing_date,
                                        "dd/MM/yyyy"
                                    )}
                                </p>
                            </Grid>
                        </>
                    )}
                    {candidateData?.certification_no && (
                        <>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    Certificate Number
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {candidateData?.certification_no}
                                </p>
                            </Grid>
                        </>
                    )}
                    {candidateData?.certification_issuing_district && (
                        <>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    Certificate Issuing District
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {candidateData?.certification_issuing_district}
                                </p>
                            </Grid>
                        </>
                    )}
                    {candidateData?.certification_valid_upto && (
                        <>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>Valid Upto</p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {fDate(
                                        candidateData?.certification_valid_upto,
                                        "dd/MM/yyyy"
                                    )}
                                </p>
                            </Grid>
                        </>
                    )}

                    {Number(candidateData?.domicile) === 1 && (
                        <>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <p className={`${className}--subheading`}>
                                    Sub Category Details
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    Differently abled(PH)
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {Number(candidateData?.is_differently_abled) ===
                                        1
                                        ? "Yes"
                                        : "No"}
                                </p>
                            </Grid>
                            {Number(candidateData?.is_differently_abled) === 1 &&
                                <>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--text`}>
                                            Differently abled Type
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--subText`}>
                                            {Number(candidateData?.is_differently_abled) === 1
                                                ? candidateData?.differently_abled_type
                                                : ""}
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--text`}>
                                            Certificate Issuing Date
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--subText`}>
                                            {fDate(
                                                candidateData?.differently_abled_certification_issuing_date,
                                                "dd/MM/yyyy"
                                            )}
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--text`}>
                                            Certificate Number
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--subText`}>
                                            {candidateData?.differently_abled_certificate_no}
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--text`}>
                                            Do you need a scribe?
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--subText`}>
                                            {Number(candidateData?.need_scribe) === 1
                                                ? 'Yes'
                                                : "No"}
                                        </p>
                                    </Grid>
                                    {Number(candidateData?.need_scribe) === 1 &&
                                        <>
                                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                                <p className={`${className}--text`}>
                                                    Will you bring your own scribe?
                                                </p>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                                <p className={`${className}--subText`}>
                                                    {Number(candidateData?.own_scribe) === 1
                                                        ? "Yes"
                                                        : "No"}
                                                </p>
                                            </Grid>
                                        </>
                                    }
                                </>
                            }
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    Ex-Servicemen
                                </p>
                            </Grid>

                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {Number(candidateData?.is_exserviceman) === 1
                                        ? "Yes"
                                        : "No"}
                                </p>
                            </Grid>
                            {Number(candidateData?.is_exserviceman) === 1 && (
                                <>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--text`}>
                                            Date of Attestation
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--subText`}>
                                            {fDate(
                                                candidateData?.exserviceman_attestation_date,
                                                "dd/MM/yyyy"
                                            )}
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--text`}>
                                            Date of Discharge
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--subText`}>
                                            {fDate(
                                                candidateData?.exserviceman_discharge_date,
                                                "dd/MM/yyyy"
                                            )}
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--text`}>
                                            Have you availed the benefits of an
                                            ex-servicemen in any government job in the
                                            past?
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--subText`}>
                                            {Number(
                                                candidateData?.exservicemen_availed_benefits
                                            ) === 1
                                                ? "Yes"
                                                : "No"}
                                        </p>
                                    </Grid>
                                    {Number(
                                        candidateData?.exservicemen_availed_benefits
                                    ) === 1 && (
                                            <>
                                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                                    <p className={`${className}--text`}>
                                                        Have you secured employment under the
                                                        state government in group C&D and are
                                                        applying for another employment in a
                                                        higher grade or cadre in Group C/D under
                                                        the state government
                                                    </p>
                                                </Grid>
                                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                                    <p className={`${className}--subText`}>
                                                        {Number(
                                                            candidateData?.under_state_govt_group_cd_apply_another_group
                                                        ) === 1
                                                            ? "Yes"
                                                            : "No"}
                                                    </p>
                                                </Grid>
                                            </>
                                        )}
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--text`}>
                                            Is your name registered in any District
                                            Soldier Welfare and Rehabilitation Office
                                            Employment Exchange located in Uttarakhand
                                            State?
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--subText`}>
                                            {Number(
                                                candidateData?.is_registered_district_soldier_welfare
                                            ) === 1
                                                ? "Yes"
                                                : "No"}
                                        </p>
                                    </Grid>
                                    {/* {Number(
                                  candidateData?.exservicemen_availed_benefits
                                ) === 1 && (
                                    <>
                                      <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className="final-preview--textred print-none">
                                          (As per advertisement you are not eligible
                                          to avail the benefits of ex-servicemen
                                          reservation category. You can continue as
                                          Non-Ex-Servicemen candidate.)
                                        </p>
                                      </Grid>
                                      <Grid item lg={6} md={6} sm={6} xs={6} />
                                    </>
                                  )} */}

                                </>
                            )}
                            {Number(
                                candidateData?.is_registered_district_soldier_welfare
                            ) === 1 && (
                                    <>
                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <p className={`${className}--text`}>
                                                Enter Registration Number
                                            </p>
                                        </Grid>
                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <p className={`${className}--subText`}>
                                                {
                                                    candidateData?.district_soldier_welfare_registration_no
                                                }
                                            </p>
                                        </Grid>

                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <p className={`${className}--text`}>
                                                Office Name
                                            </p>
                                        </Grid>
                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <p className={`${className}--subText`}>
                                                {
                                                    candidateData?.district_soldier_welfare_office_name
                                                }
                                            </p>
                                        </Grid>
                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <p className={`${className}--text`}>
                                                Date of Registration
                                            </p>
                                        </Grid>
                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <p className={`${className}--subText`}>
                                                {fDate(
                                                    candidateData?.district_soldier_welfare_registration_date,
                                                    "dd/MM/yyyy"
                                                )}
                                            </p>
                                        </Grid>
                                    </>
                                )}

                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    Dependent of Freedom Fighter (DFF)
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {Number(candidateData?.dff) === 1
                                        ? "Yes"
                                        : "No"}
                                </p>
                            </Grid>
                            {Number(candidateData?.dff) === 1 && (
                                <>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--text`}>
                                            Certificate Issuing Date
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--subText`}>
                                            {fDate(
                                                candidateData?.dff_certification_issuing_date,
                                                "dd/MM/yyyy"
                                            )}
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--text`}>
                                            Certificate Number
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--subText`}>
                                            {candidateData?.dff_certificate_no}
                                        </p>
                                    </Grid>
                                </>
                            )}
                            <Grid item lg={6} md={6} sm={6} xs={6} pr={6}>
                                <p className={`${className}--text`}>
                                    Are you a permanent resident of the State of Uttarakhand
                                    covered by Government Order No. 179/XXX(2)/2021-30(2)/2019,
                                    dated 31st August 2021, for such affected children{" "}
                                    <strong>
                                        (whose biological/adoptive parents both died after the birth
                                        of the child)?
                                    </strong>{" "}
                                    within a period of up to 21 years) OR{" "}
                                    <strong>Orphan Child</strong> residing in government/voluntary
                                    homes functional and registered under the Department of Women
                                    Empowerment and Child Development in the state of Uttarakhand
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {Number(
                                        candidateData?.permanent_resident_uttarakhand_covered_by_govt_order
                                    ) === 1
                                        ? "Yes"
                                        : "No"}
                                </p>
                            </Grid>
                            {Number(candidateData?.permanent_resident_uttarakhand_covered_by_govt_order) === 1 && (
                                <>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--text`}>
                                            Certificate Issuing Date
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--subText`}>
                                            {fDate(
                                                candidateData?.orphan_certification_issuing_date,
                                                "dd/MM/yyyy"
                                            )}
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--text`}>
                                            Certificate Number
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--subText`}>
                                            {candidateData?.orphan_certificate_no}
                                        </p>
                                    </Grid>
                                </>
                            )}
                            {candidateData?.gender === "Female" && (
                                <>
                                    <Grid item lg={6} md={6} sm={6} xs={6} pr={6}>
                                        <p className={`${className}--text`}>
                                            Uttarakhand Female
                                        </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className={`${className}--subText`}>
                                            {Number(
                                                candidateData?.is_uttarakhand_female
                                            ) === 1
                                                ? "Yes"
                                                : "No"}
                                        </p>
                                    </Grid>
                                </>
                            )}
                        </>
                    )}

                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--text`}>
                            Claimed Category/Sub Category <br />
                            <span className="print-none">
                                (Reservation,Age ,Fee, Relaxation and other
                                applicable benefit)
                            </span>
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--subText boldBlue`}>
                            {claimedMsg}
                        </p>
                    </Grid>
                </Grid>
            </div>
            {/* for print preview */}
            <div className="print-view  requiredSec">
                <div className="print-details d-flex">
                    <div className="w-50">
                        <p className={`${className}--text`}>Category</p>
                    </div>
                    <div className="w-50">
                        <p className={`${className}--subText custom-rht2`}>
                            {candidateData?.category}
                        </p>
                    </div>
                </div>
                {candidateData?.certification_issuing_authority && (
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--text`}>
                                Certification Issuing Authority
                            </p>
                        </div>
                        <div className="w-50">
                            <p className={`${className}--subText`}>
                                {candidateData?.certification_issuing_authority}
                            </p>
                        </div>
                    </div>
                )}
                {candidateData?.certification_issuing_date && (
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--text`}>
                                Certificate Issuing Date
                            </p>
                        </div>
                        <div className="w-50">
                            <p className={`${className}--subText`}>
                                {fDate(
                                    candidateData?.certification_issuing_date,
                                    "dd/MM/yyyy"
                                )}
                            </p>
                        </div>
                    </div>
                )}
                {candidateData?.certification_no && (
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--text`}>
                                Certificate Number
                            </p>
                        </div>
                        <div className="w-50">
                            <p className={`${className}--subText`}>
                                {candidateData?.certification_no}
                            </p>
                        </div>
                    </div>
                )}
                {candidateData?.certification_issuing_district && (
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--text`}>
                                Certificate Issuing District
                            </p>
                        </div>
                        <div className="w-50">
                            <p className={`${className}--subText`}>
                                {candidateData?.certification_issuing_district}
                            </p>
                        </div>
                    </div>
                )}
                {candidateData?.certification_valid_upto && (
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--text`}>Valid Upto</p>
                        </div>
                        <div className="w-50">
                            <p className={`${className}--subText`}>
                                {fDate(
                                    candidateData?.certification_valid_upto,
                                    "dd/MM/yyyy"
                                )}
                            </p>
                        </div>
                    </div>
                )}
                {Number(candidateData?.domicile) === 1 && (
                    <>
                        <div className="print-details d-flex">
                            <div className="w-100">
                                <p className={`${className}--subheading`}>
                                    Sub Category Details
                                </p>
                            </div>
                        </div>
                        <div className="print-details d-flex">
                            <div className="w-50">
                                <p className={`${className}--text`}>
                                    Differently abled(PH)
                                </p>
                            </div>
                            <div className="w-50">
                                <p className={`${className}--subText`}>
                                    {Number(candidateData?.is_differently_abled) ===
                                        1
                                        ? "Yes"
                                        : "No"}
                                </p>
                            </div>
                        </div>
                        {Number(candidateData?.is_differently_abled) === 1 &&
                            <>
                                <div className="print-details d-flex">
                                    <div className="w-50">
                                        <p className={`${className}--text`}>
                                            Differently abled Type
                                        </p>
                                    </div>
                                    <div className="w-50">
                                        <p className={`${className}--subText`}>
                                            {Number(candidateData?.is_differently_abled) === 1
                                                ? candidateData?.differently_abled_type
                                                : ""}
                                        </p>
                                    </div>
                                </div>
                                <div className="print-details d-flex">
                                    <div className="w-50">
                                        <p className={`${className}--text`}>
                                            Certificate Issuing Date
                                        </p>
                                    </div>
                                    <div className="w-50">
                                        <p className={`${className}--subText`}>
                                            {fDate(
                                                candidateData?.differently_abled_certification_issuing_date,
                                                "dd/MM/yyyy"
                                            )}
                                        </p>
                                    </div>
                                </div>
                                <div className="print-details d-flex">
                                    <div className="w-50">
                                        <p className={`${className}--text`}>
                                            Certificate Number
                                        </p>
                                    </div>
                                    <div className="w-50">
                                        <p className={`${className}--subText`}>
                                            {candidateData?.differently_abled_certificate_no}
                                        </p>
                                    </div>
                                </div>
                                <div className="print-details d-flex">
                                    <div className="w-50">
                                        <p className={`${className}--text`}>
                                            Do you need a scribe?
                                        </p>
                                    </div>
                                    <div className="w-50">
                                        <p className={`${className}--subText`}>
                                            {Number(candidateData?.need_scribe) === 1
                                                ? 'Yes'
                                                : "No"}
                                        </p>
                                    </div>
                                </div>
                                {Number(candidateData?.need_scribe) === 1 &&
                                    <div className="print-details d-flex">
                                        <div className="w-50">
                                            <p className={`${className}--text`}>
                                                Will you bring your own scribe?
                                            </p>
                                        </div>
                                        <div className="w-50">
                                            <p className={`${className}--subText`}>
                                                {Number(candidateData?.own_scribe) === 1
                                                    ? "Yes"
                                                    : "No"}
                                            </p>
                                        </div>
                                    </div>
                                }
                            </>
                        }
                        <div className="print-details d-flex">
                            <div className="w-50">
                                <p className={`${className}--text`}>
                                    Ex-Servicemen
                                </p>
                            </div>
                            <div className="w-50">
                                <p className={`${className}--subText`}>
                                    {Number(candidateData?.is_exserviceman) === 1
                                        ? "Yes"
                                        : "No"}
                                </p>
                            </div>
                        </div>
                        {Number(candidateData?.is_exserviceman) === 1 && (
                            <>
                                <div className="print-details d-flex">
                                    <div className="w-50">
                                        <p className={`${className}--text`}>
                                            Date of Attestation
                                        </p>
                                    </div>
                                    <div className="w-50">
                                        <p className={`${className}--subText`}>
                                            {fDate(
                                                candidateData?.exserviceman_attestation_date,
                                                "dd/MM/yyyy"
                                            )}
                                        </p>
                                    </div>
                                </div>
                                <div className="print-details d-flex">
                                    <div className="w-50">
                                        <p className={`${className}--text`}>
                                            Date of Discharge
                                        </p>
                                    </div>
                                    <div className="w-50">
                                        <p className={`${className}--subText`}>
                                            {fDate(
                                                candidateData?.exserviceman_discharge_date,
                                                "dd/MM/yyyy"
                                            )}
                                        </p>
                                    </div>
                                </div>
                                <div className="print-details d-flex">
                                    <div className="w-50">
                                        <p className={`${className}--text`}>
                                            Have you availed the benefits of an
                                            ex-servicemen in any government job in the
                                            past?
                                        </p>
                                    </div>
                                    <div className="w-50">
                                        <p className={`${className}--subText`}>
                                            {Number(
                                                candidateData?.exservicemen_availed_benefits
                                            ) === 1
                                                ? "Yes"
                                                : "No"}
                                        </p>
                                    </div>
                                </div>
                                {Number(
                                    candidateData?.exservicemen_availed_benefits
                                ) === 1 && (
                                        <div className="print-details d-flex">
                                            <div className="w-50">
                                                <p className={`${className}--text`}>
                                                    Have you secured employment under the
                                                    state government in group C&D and are
                                                    applying for another employment in a
                                                    higher grade or cadre in Group C/D under
                                                    the state government?
                                                </p>
                                            </div>
                                            <div className="w-50">
                                                <p className={`${className}--subText`}>
                                                    {Number(
                                                        candidateData?.under_state_govt_group_cd_apply_another_group
                                                    ) === 1
                                                        ? "Yes"
                                                        : "No"}
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                <div className="print-details d-flex">
                                    <div className="w-50">
                                        <p className={`${className}--text`}>
                                            Is your name registered in any District
                                            Soldier Welfare and Rehabilitation Office
                                            Employment Exchange located in Uttarakhand
                                            State?
                                        </p>
                                    </div>
                                    <div className="w-50">
                                        <p className={`${className}--subText`}>
                                            {Number(
                                                candidateData?.is_registered_district_soldier_welfare
                                            ) === 1
                                                ? "Yes"
                                                : "No"}
                                        </p>
                                    </div>
                                </div>
                            </>
                        )}
                        {Number(
                            candidateData?.is_registered_district_soldier_welfare
                        ) === 1 && (
                                <>
                                    <div className="print-details d-flex">
                                        <div className="w-50">
                                            <p className={`${className}--text`}>
                                                Enter Registration Number
                                            </p>
                                        </div>
                                        <div className="w-50">
                                            <p className={`${className}--subText`}>
                                                {
                                                    candidateData?.district_soldier_welfare_registration_no
                                                }
                                            </p>
                                        </div>
                                    </div>
                                    <div className="print-details d-flex">
                                        <div className="w-50">
                                            <p className={`${className}--text`}>
                                                Office Name
                                            </p>
                                        </div>
                                        <div className="w-50">
                                            <p className={`${className}--subText`}>
                                                {
                                                    candidateData?.district_soldier_welfare_office_name
                                                }
                                            </p>
                                        </div>
                                    </div>
                                    <div className="print-details d-flex">
                                        <div className="w-50">
                                            <p className={`${className}--text`}>
                                                Date of Registration
                                            </p>
                                        </div>
                                        <div className="w-50">
                                            <p className={`${className}--subText`}>
                                                {fDate(
                                                    candidateData?.district_soldier_welfare_registration_date,
                                                    "dd/MM/yyyy"
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </>
                            )}

                        <div className="print-details d-flex">
                            <div className="w-50">
                                <p className={`${className}--text`}>
                                    Dependent of Freedom Fighter (DFF)
                                </p>
                            </div>
                            <div className="w-50">
                                <p className={`${className}--subText`}>
                                    {Number(candidateData?.dff) === 1
                                        ? "Yes"
                                        : "No"}
                                </p>
                            </div>
                        </div>
                        {Number(candidateData?.dff) === 1 && (
                            <>
                                <div className="print-details d-flex">
                                    <div className="w-50">
                                        <p className={`${className}--text`}>
                                            Certificate Issuing Date
                                        </p>
                                    </div>
                                    <div className="w-50">
                                        <p className={`${className}--subText`}>
                                            {fDate(
                                                candidateData?.dff_certification_issuing_date,
                                                "dd/MM/yyyy"
                                            )}
                                        </p>
                                    </div>
                                </div>
                                <div className="print-details d-flex">
                                    <div className="w-50">
                                        <p className={`${className}--text`}>
                                            Certificate Number
                                        </p>
                                    </div>
                                    <div className="w-50">
                                        <p className={`${className}--subText`}>
                                            {candidateData?.dff_certificate_no}
                                        </p>
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="print-details d-flex">
                            <div className="w-50">
                                <p className={`${className}--text`}>
                                    Are you a permanent resident of the State of Uttarakhand
                                    covered by Government Order No. 179/XXX(2)/2021-30(2)/2019,
                                    dated 31st August 2021, for such affected children{" "}
                                    <strong>
                                        (whose biological/adoptive parents both died after the birth
                                        of the child)?
                                    </strong>{" "}
                                    within a period of up to 21 years) OR{" "}
                                    <strong>Orphan Child</strong> residing in government/voluntary
                                    homes functional and registered under the Department of Women
                                    Empowerment and Child Development in the state of Uttarakhand
                                </p>
                            </div>
                            <div className="w-50">
                                <p className={`${className}--subText`}>
                                    {Number(
                                        candidateData?.permanent_resident_uttarakhand_covered_by_govt_order
                                    ) === 1
                                        ? "Yes"
                                        : "No"}
                                </p>
                            </div>
                        </div>
                        {Number(candidateData?.permanent_resident_uttarakhand_covered_by_govt_order) === 1 && (
                            <>
                                <div className="print-details d-flex">
                                    <div className="w-50">
                                        <p className={`${className}--text`}>
                                            Certificate Issuing Date
                                        </p>
                                    </div>
                                    <div className="w-50">
                                        <p className={`${className}--subText`}>
                                            {fDate(
                                                candidateData?.orphan_certification_issuing_date,
                                                "dd/MM/yyyy"
                                            )}
                                        </p>
                                    </div>
                                </div>
                                <div className="print-details d-flex">
                                    <div className="w-50">
                                        <p className={`${className}--text`}>
                                            Certificate Number
                                        </p>
                                    </div>
                                    <div className="w-50">
                                        <p className={`${className}--subText`}>
                                            {candidateData?.orphan_certificate_no}
                                        </p>
                                    </div>
                                </div>
                            </>
                        )}
                        {candidateData?.gender === "Female" && (
                            <div className="print-details d-flex">
                                <div className="w-50">
                                    <p className={`${className}--text`}>
                                        Uttarakhand Female
                                    </p>
                                </div>
                                <div className="w-50">
                                    <p className={`${className}--subText`}>
                                        {Number(
                                            candidateData?.is_uttarakhand_female
                                        ) === 1
                                            ? "Yes"
                                            : "No"}
                                    </p>
                                </div>
                            </div>
                        )}
                    </>
                )}
                <div className="print-details d-flex">
                    <div className="w-50">
                        <p className={`${className}--text`}>
                            Claimed Category/Sub Category <br />
                            <span className="print-none">
                                (Reservation,Age ,Fee, Relaxation and other
                                applicable benefit)
                            </span>
                        </p>
                    </div>
                    <div className="w-50">
                        <p className={`${className}--subText boldBlue`}>
                            {claimedMsg}
                        </p>
                    </div>
                </div>
            </div>
        </fieldset>
    )
}

export default CategoryDetails;